export class ServiceContext {
  public request: Request;
  public response: Response | undefined;

  constructor(request: Request) {
    this.request = request;
  }
}
